import * as yup from "yup";
import { Max, Min, Validation } from "../utils/Validation.utils";
export const BugReportInitialValues = {
    message: ""
};
export const BugReportSchema = yup.object().shape({
    message: yup
        .string()
        .min(Min.Message, Validation.Min)
        .max(Max.Message, Validation.Max)
        .required(Validation.Required)
});
